import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-6 mb-8 bg-white rounded-lg lg:p-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "mb-6 text-xl font-bold text-primary-500" }, "IX. OB/GYN History (For female patients only) 婦人科問診（女性のみ）", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "mb-6 font-bold" }, "1. Menstrual history 月経（生理）について", -1)
const _hoisted_4 = { class: "pl-5 mb-6" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("ol", {
  class: "list-[lower-alpha]",
  start: "1"
}, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-darkgray-800" }, "At what age did your first menstrual period start? 初めて生理があったのはいつですか")
  ])
], -1)
const _hoisted_6 = { class: "flex space-x-[70px] mt-2.5" }
const _hoisted_7 = { class: "w-full lg:w-1/2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "hidden w-1/2 lg:block" }, null, -1)
const _hoisted_9 = { class: "pl-5 mb-6" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("ol", {
  class: "list-[lower-alpha]",
  start: "2"
}, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-darkgray-800" }, "Have you reached menopause? 閉経はいつですか")
  ])
], -1)
const _hoisted_11 = { class: "lg:columns-2 space-y-2 gap-x-[70px] mt-2.5" }
const _hoisted_12 = {
  key: 0,
  class: "lg:columns-2 space-y-2 gap-x-[70px] mt-2.5"
}
const _hoisted_13 = { class: "pl-7" }
const _hoisted_14 = { class: "pl-5 mb-6" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("ol", {
  class: "list-[lower-alpha]",
  start: "3"
}, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-darkgray-800" }, "Are your periods regular? 生理は順調ですか")
  ])
], -1)
const _hoisted_16 = { class: "lg:columns-2 space-y-2 gap-x-[70px] mt-2.5" }
const _hoisted_17 = {
  key: 0,
  class: "mt-2 text-sm text-red-600"
}
const _hoisted_18 = { class: "pl-5 mb-6" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("ol", {
  class: "list-[lower-alpha]",
  start: "4"
}, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-darkgray-800" }, "Interval 生理周期について")
  ])
], -1)
const _hoisted_20 = { class: "flex space-x-[70px] mt-2.5" }
const _hoisted_21 = { class: "w-full lg:w-1/2" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "hidden w-1/2 lg:block" }, null, -1)
const _hoisted_23 = { class: "pl-5 mb-6" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("ol", {
  class: "list-[lower-alpha]",
  start: "5"
}, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-darkgray-800" }, "How long does your period usually last? 生理は何日間ありますか")
  ])
], -1)
const _hoisted_25 = { class: "flex space-x-[70px] mt-2.5" }
const _hoisted_26 = { class: "w-full lg:w-1/2" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "hidden w-1/2 lg:block" }, null, -1)
const _hoisted_28 = { class: "pl-5 mb-6" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("ol", {
  class: "list-[lower-alpha]",
  start: "6"
}, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-darkgray-800" }, "Describe your period flow 生理の量")
  ])
], -1)
const _hoisted_30 = { class: "lg:columns-2 space-y-2 gap-x-[70px] mt-2.5" }
const _hoisted_31 = {
  key: 0,
  class: "mt-2 text-sm text-red-600"
}
const _hoisted_32 = { class: "pl-5 mb-6" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("ol", {
  class: "list-[lower-alpha]",
  start: "7"
}, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-darkgray-800" }, "Do you experience period pain? 生理痛は")
  ])
], -1)
const _hoisted_34 = { class: "lg:columns-2 space-y-2 gap-x-[70px] mt-2.5" }
const _hoisted_35 = {
  key: 0,
  class: "mt-2 text-sm text-red-600"
}
const _hoisted_36 = { class: "pl-5 mb-6" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("ol", {
  class: "list-[lower-alpha]",
  start: "8"
}, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-darkgray-800" }, "Do you use painkillers for period pain? 生理痛で薬を飲みますか")
  ])
], -1)
const _hoisted_38 = { class: "lg:columns-2 space-y-2 gap-x-[70px] mt-2.5" }
const _hoisted_39 = {
  key: 0,
  class: "mt-2 text-sm text-red-600"
}
const _hoisted_40 = {
  key: 0,
  class: "lg:columns-2 space-y-2 gap-x-[70px] mt-2.5"
}
const _hoisted_41 = { class: "pl-7" }
const _hoisted_42 = { class: "pl-5 mb-6" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("ol", {
  class: "list-[lower-alpha]",
  start: "9"
}, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-darkgray-800" }, "Date of your last period 最終月経はいつです")
  ])
], -1)
const _hoisted_44 = { class: "flex lg:flex-row flex-col lg:space-x-[70px] lg:space-y-0 space-y-2.5 mt-2.5" }
const _hoisted_45 = { class: "w-full lg:w-1/2" }
const _hoisted_46 = { class: "w-full lg:w-1/2" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "my-8 border-b border-black/[.04]" }, null, -1)
const _hoisted_48 = { class: "mb-6" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("p", { class: "text-darkgray-800" }, "2. Have you ever had sexual intercourse? 性交渉の経験はありますか", -1)
const _hoisted_50 = { class: "lg:columns-2 space-y-2 gap-x-[70px] mt-2.5" }
const _hoisted_51 = {
  key: 0,
  class: "mt-2 text-sm text-red-600"
}
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "my-8 border-b border-black/[.04]" }, null, -1)
const _hoisted_53 = { class: "mb-6" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("p", { class: "text-darkgray-800" }, "3. Have you ever had any STDs? 性感染症にかかったことはありますか", -1)
const _hoisted_55 = { class: "lg:columns-2 space-y-2 gap-x-[70px] mt-2.5" }
const _hoisted_56 = {
  key: 0,
  class: "mt-2 text-sm text-red-600"
}
const _hoisted_57 = {
  key: 0,
  class: "lg:columns-2 space-y-2 gap-x-[70px] mt-2.5"
}
const _hoisted_58 = { class: "pl-7" }
const _hoisted_59 = { class: "pl-7 flex flex-col space-y-2.5" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "flex space-x-[70px] mt-2.5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "pl-8 w-1/2 flex flex-col space-y-2.5" }),
  /*#__PURE__*/_createElementVNode("div", { class: "hidden w-1/2 lg:block" })
], -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "my-8 border-b border-black/[.04]" }, null, -1)
const _hoisted_62 = { class: "mb-6" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("p", { class: "text-darkgray-800" }, "4. Are you administering hormone? ホルモン剤を使用していますか", -1)
const _hoisted_64 = { class: "lg:columns-2 space-y-2 gap-x-[70px] mt-2.5" }
const _hoisted_65 = {
  key: 0,
  class: "mt-2 text-sm text-red-600"
}
const _hoisted_66 = {
  key: 1,
  class: "flex space-x-[70px] mt-2.5"
}
const _hoisted_67 = { class: "w-full pl-8 lg:w-1/2" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", { class: "hidden w-1/2 lg:block" }, null, -1)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("div", { class: "my-8 border-b border-black/[.04]" }, null, -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("p", { class: "mb-6 font-bold" }, "5. Pregnancy history 妊娠歴について", -1)
const _hoisted_71 = { class: "pl-5 mb-6" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("ol", {
  class: "list-[lower-alpha]",
  start: "1"
}, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-darkgray-800" }, "Are you pregnant or possibly pregnant? 妊娠していますか、またその可能性はありますか")
  ])
], -1)
const _hoisted_73 = { class: "lg:columns-2 space-y-2 gap-x-[70px] mt-2.5" }
const _hoisted_74 = {
  key: 0,
  class: "mt-2 text-sm text-red-600"
}
const _hoisted_75 = {
  key: 1,
  class: "lg:columns-2 space-y-2 gap-x-[70px] mt-2.5"
}
const _hoisted_76 = { class: "pl-7" }
const _hoisted_77 = { class: "pl-5 mb-6" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("ol", {
  class: "list-[lower-alpha]",
  start: "2"
}, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-darkgray-800" }, "Have you ever been pregnant? これまでに妊娠したことがありますか")
  ])
], -1)
const _hoisted_79 = { class: "lg:columns-2 space-y-2 gap-x-[70px] mt-2.5" }
const _hoisted_80 = {
  key: 0,
  class: "mt-2 text-sm text-red-600"
}
const _hoisted_81 = { class: "pl-5 mb-6" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("ol", {
  class: "list-[lower-alpha]",
  start: "3"
}, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-darkgray-800" }, "Have you ever had a miscarriage or abortion? 自然流産や人工流産の経験はありますか")
  ])
], -1)
const _hoisted_83 = { class: "lg:columns-2 space-y-2 gap-x-[70px] mt-2.5" }
const _hoisted_84 = {
  key: 0,
  class: "mt-2 text-sm text-red-600"
}
const _hoisted_85 = {
  key: 1,
  class: "space-y-2 PRAXXYSlive2023 mt-2.5"
}
const _hoisted_86 = { class: "pl-7 flex flex-col space-y-2.5" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("label", { class: "block ml-2 text-primary-600" }, " Miscarriage/自然流産 ", -1)
const _hoisted_88 = { class: "space-y-2 pl-7" }
const _hoisted_89 = /*#__PURE__*/_createElementVNode("label", { class: "block ml-2 text-primary-600" }, " Abortion/人工中絶 ", -1)
const _hoisted_90 = { class: "space-y-2 pl-7" }
const _hoisted_91 = { class: "pl-5 mb-6" }
const _hoisted_92 = /*#__PURE__*/_createElementVNode("ol", {
  class: "list-[lower-alpha]",
  start: "4"
}, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("p", { class: "text-darkgray-800" }, "Do you have any children? If yes, please give details お子様がいらっしゃる方はご記入ください")
  ])
], -1)
const _hoisted_93 = { class: "lg:columns-2 space-y-2 gap-x-[70px] mt-2.5" }
const _hoisted_94 = {
  key: 0,
  class: "mb-6"
}
const _hoisted_95 = { class: "col-span-8 lg:col-span-6" }
const _hoisted_96 = { class: "font-bold text-darkgray-800" }
const _hoisted_97 = { class: "col-span-4 text-right lg:col-span-6" }
const _hoisted_98 = ["onClick"]
const _hoisted_99 = { class: "col-span-full lg:col-span-6" }
const _hoisted_100 = { class: "lg:col-span-6 col-span-full" }
const _hoisted_101 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2 font-bold text-darkgray-800" }, "Delivery method/分娩方法", -1)
const _hoisted_102 = { class: "space-y-2" }
const _hoisted_103 = ["disabled"]
const _hoisted_104 = /*#__PURE__*/_createElementVNode("div", { class: "my-8 border-b border-black/[.04]" }, null, -1)
const _hoisted_105 = { class: "mb-6" }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("p", { class: "text-darkgray-800" }, "6. Are you breastfeeding? 授乳中ですか", -1)
const _hoisted_107 = { class: "lg:columns-2 space-y-2 gap-x-[70px] mt-2.5" }
const _hoisted_108 = {
  key: 0,
  class: "mt-2 text-sm text-red-600"
}
const _hoisted_109 = /*#__PURE__*/_createElementVNode("div", { class: "my-8 border-b border-black/[.04]" }, null, -1)
const _hoisted_110 = { class: "mb-6" }
const _hoisted_111 = /*#__PURE__*/_createElementVNode("p", { class: "text-darkgray-800" }, "7. Did you undergo breast augmentation surgery and breast reconstruction? 豊胸手術、乳房再建術をしていますか", -1)
const _hoisted_112 = { class: "lg:columns-2 space-y-2 gap-x-[70px] mt-2.5" }
const _hoisted_113 = {
  key: 0,
  class: "mt-2 text-sm text-red-600"
}
const _hoisted_114 = /*#__PURE__*/_createElementVNode("div", { class: "my-8 border-b border-black/[.04]" }, null, -1)
const _hoisted_115 = { class: "mb-6" }
const _hoisted_116 = /*#__PURE__*/_createElementVNode("p", { class: "text-darkgray-800" }, "8. Have you ever been tested for breasts? 乳房の検査を受けたことはありますか", -1)
const _hoisted_117 = { class: "lg:columns-2 space-y-2 gap-x-[70px] mt-2.5" }
const _hoisted_118 = {
  key: 0,
  class: "mt-2 text-sm text-red-600"
}
const _hoisted_119 = {
  key: 1,
  class: "space-y-2 gap-x-[70px] mt-2.5"
}
const _hoisted_120 = { class: "pl-7 flex flex-col space-y-2.5 w-1/4" }
const _hoisted_121 = { class: "space-y-2 pl-7" }
const _hoisted_122 = { class: "space-y-2 pl-7" }
const _hoisted_123 = { class: "space-y-2 pl-7" }
const _hoisted_124 = /*#__PURE__*/_createElementVNode("div", { class: "my-8 border-b border-black/[.04]" }, null, -1)
const _hoisted_125 = { class: "mb-6" }
const _hoisted_126 = /*#__PURE__*/_createElementVNode("p", { class: "text-darkgray-800" }, "9. Have you ever had a pap smear? 子宮がん検診を受けたことがありますか", -1)
const _hoisted_127 = { class: "lg:columns-2 space-y-2 gap-x-[70px] mt-2.5" }
const _hoisted_128 = {
  key: 0,
  class: "mt-2 text-sm text-red-600"
}
const _hoisted_129 = { class: "lg:columns-2 space-y-2 gap-x-[70px] mt-2.5" }
const _hoisted_130 = {
  key: 0,
  class: "pl-7 flex flex-col space-y-2.5"
}
const _hoisted_131 = { class: "mb-3" }
const _hoisted_132 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-darkgray-800" }, "Result 検査結果", -1)
const _hoisted_133 = /*#__PURE__*/_createElementVNode("div", { class: "hidden lg:block spacer h-36" }, null, -1)

import TextInput from '@/components/inputs/TextInput.vue';
import RadioGroup from '@/components/inputs/RadioGroup.vue';
import CalendarPicker from '@/components/CalendarPicker.vue';
import MedicalService from '@/classes/MedicalService';
import CheckboxInput from '@/components/inputs/CheckboxInput.vue';

import { 
    IChildrenDelivery
} from '@/interfaces/PatientInterface'

import { onMounted, ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'OBGYNHistory',
  props: {
    form: {
        type: Object,
        required: true
    },
    errors: {
        type: Object,
        required: true
    },
    disableInputs: {
        type: Boolean,
        required: true
    },
},
  setup(__props) {

const props = __props

const item = ref(props.form)
const menstruationOptions = MedicalService.getDefaultOptions('menstruation')
const menopauseOptions = MedicalService.getDefaultOptions('menopause')

const std = [
    { 
        label: 'Chlamydia/クラミジア',
        value: 'chlamydia' 
    },
    { 
        label: 'Gonorrhoea/淋病',
        value: 'gonorrhoea' 
    },
    { 
        label: 'Trichomonas/トリコモナス',
        value: 'trichomonas' 
    },
    { 
        label: 'HIV/エイズ',
        value: 'hiv' 
    },
    { 
        label: 'Other/その他',
        value: 'other' 
    },
]

const inStdType = (val : string): boolean => {
    return item.value.stds_type.findIndex((type:any) => type == val) != -1
}

const addRemoveStdType = (val : string):void => {
    const index = item.value.stds_type.findIndex((member:any) => member == val)

    if(index != -1){
        item.value.stds_type.splice(index, 1);
    } else {
        item.value.stds_type.push(val);
    }
}

const getOtherValue = ():number => {

    const otherValue = item.value.stds_type.filter((val:any) => !std.map((type:any) => type.value).includes(val));
    const index = item.value.stds_type.indexOf(otherValue[0])

    if(index != -1){
        return index;
    } 
    
    if(inStdType('other')){
        return item.value.stds_type.length;
    } 
    
    return -1 ;
}

const hasChild = (value:any):void => {
    if(value == "Yes"){
        addChild()
    } else {
        item.value.children_delivery = [];
    }
}

const addChild = ():void => {
    item.value.children_delivery.push({
        child_order : item.value.children_delivery.length + 1,
        age_deliver : null,
        is_vaginal_delivery : 'No',
        is_csection_delivery : 'No'
    })
}

const removeChild = (index:number):void => {
    item.value.children_delivery.splice(index, 1)
}

const setDate = (value:boolean, param:any, test:string):void => {
    if(value){
        param[test] = new Date();
    } else {
        param[test] = null;
    }
}
const getOrdinal = (n:number):string => {
  let ord = 'th';

  if (n % 10 == 1 && n % 100 != 11)
  {
    ord = 'st';
  }
  else if (n % 10 == 2 && n % 100 != 12)
  {
    ord = 'nd';
  }
  else if (n % 10 == 3 && n % 100 != 13)
  {
    ord = 'rd';
  }

  return ord;
}

watch(() => item.value.is_currently_menstruating,
    (val) => {
        if(val === 'Yes') item.value.last_menstruation_date = null
    },
    { immediate: true }
);

onMounted(() => {
    setTimeout(() => {
        if(!item.value.is_currently_menstruating || item.value.is_currently_menstruating === 'Yes') {
            item.value.last_menstruation_date = null
        }
    }, 2000)
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(TextInput, {
            id: "first_menstruation_age",
            type: "text",
            placeholder: "Age 年齢",
            disabled: __props.disableInputs,
            modelValue: item.value.first_menstruation_age,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((item.value.first_menstruation_age) = $event)),
            error: __props.errors['ob_gyn_history.first_menstruation_age'] ? __props.errors['ob_gyn_history.first_menstruation_age'][0] : null
          }, null, 8, ["disabled", "modelValue", "error"])
        ]),
        _hoisted_8
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _createVNode(RadioGroup, {
          options: [
                            { id: 'yes', label: 'Yes/はい', value: 'Yes'},
                            { id: 'no', label: 'No/いいえ', value: 'No'},
                        ],
          name: "is_menopause_reached",
          disabled: __props.disableInputs,
          modelValue: item.value.is_menopause_reached,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((item.value.is_menopause_reached) = $event)),
          error: __props.errors['ob_gyn_history.is_menopause_reached'] ? __props.errors['ob_gyn_history.is_menopause_reached'][0] : null
        }, null, 8, ["disabled", "modelValue", "error"])
      ]),
      (item.value.is_menopause_reached == 'Yes')
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(TextInput, {
                id: "menopause_age",
                type: "text",
                placeholder: "If yes, what age? 年齢",
                disabled: __props.disableInputs,
                modelValue: item.value.menopause_age,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((item.value.menopause_age) = $event)),
                error: __props.errors['ob_gyn_history.menopause_age'] ? __props.errors['ob_gyn_history.menopause_age'][0] : null
              }, null, 8, ["disabled", "modelValue", "error"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_14, [
      _hoisted_15,
      _createElementVNode("div", _hoisted_16, [
        _createVNode(RadioGroup, {
          options: [
                        { id: 'yes', label: 'Yes/はい', value: 'Yes'},
                        { id: 'no', label: 'No/いいえ', value: 'No'},
                    ],
          name: "is_period_regulars",
          disabled: __props.disableInputs,
          modelValue: item.value.is_period_regular,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((item.value.is_period_regular) = $event)),
          error: __props.errors['ob_gyn_history.is_period_regular'] ? __props.errors['ob_gyn_history.is_period_regular'][0] : null
        }, null, 8, ["disabled", "modelValue", "error"])
      ]),
      (__props.errors['ob_gyn_history.is_period_regular'])
        ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(__props.errors['ob_gyn_history.is_period_regular'][0]), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_18, [
      _hoisted_19,
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createVNode(TextInput, {
            id: "period_day_interval",
            type: "text",
            placeholder: "Days 日間",
            disabled: __props.disableInputs,
            modelValue: item.value.period_day_interval,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((item.value.period_day_interval) = $event)),
            error: __props.errors['ob_gyn_history.period_day_interval'] ? __props.errors['ob_gyn_history.period_day_interval'][0] : null
          }, null, 8, ["disabled", "modelValue", "error"])
        ]),
        _hoisted_22
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _hoisted_24,
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createVNode(TextInput, {
            id: "bleeding-duration",
            type: "text",
            placeholder: "How long does your period usually last? 生理は何日間ありますか",
            modelValue: item.value.bleeding_duration_days,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((item.value.bleeding_duration_days) = $event)),
            error: __props.errors['ob_gyn_history.bleeding_duration_days'] ? __props.errors['ob_gyn_history.bleeding_duration_days'][0] : null,
            disabled: __props.disableInputs
          }, null, 8, ["modelValue", "error", "disabled"])
        ]),
        _hoisted_27
      ])
    ]),
    _createElementVNode("div", _hoisted_28, [
      _hoisted_29,
      _createElementVNode("div", _hoisted_30, [
        _createVNode(RadioGroup, {
          options: [
                        { id: 'Heavy', label: 'Heavy / 多い', value: 'Heavy'},
                        { id: 'Light', label: 'Light / 少ない', value: 'Light'},
                        { id: 'Regular', label: 'Regular / 普通', value: 'Regular'},
                    ],
          name: "period_flow",
          disabled: __props.disableInputs,
          modelValue: item.value.period_flow,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((item.value.period_flow) = $event))
        }, null, 8, ["disabled", "modelValue"]),
        (__props.errors['ob_gyn_history.period_flow'])
          ? (_openBlock(), _createElementBlock("p", _hoisted_31, _toDisplayString(__props.errors['ob_gyn_history.period_flow'][0]), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _hoisted_33,
      _createElementVNode("div", _hoisted_34, [
        _createVNode(RadioGroup, {
          options: [
                        { id: 'no', label: 'No / いいえ', value: 'No'},
                        { id: 'always', label: 'Always / いつも', value: 'Always'},
                        { id: 'yes', label: 'Yes / はい', value: 'Yes'},
                        { id: 'sometimes', label: 'Sometimes / 時々', value: 'Sometimes'},
                    ],
          name: "is_period_pain_experienced",
          disabled: __props.disableInputs,
          modelValue: item.value.is_period_pain_experienced,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((item.value.is_period_pain_experienced) = $event))
        }, null, 8, ["disabled", "modelValue"]),
        (__props.errors['ob_gyn_history.is_period_pain_experienced'])
          ? (_openBlock(), _createElementBlock("p", _hoisted_35, _toDisplayString(__props.errors['ob_gyn_history.is_period_pain_experienced'][0]), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_36, [
      _hoisted_37,
      _createElementVNode("div", _hoisted_38, [
        _createVNode(RadioGroup, {
          options: [
                        { id: 'yes', label: 'Yes/はい', value: 'Yes'},
                        { id: 'no', label: 'No/いいえ', value: 'No'},
                    ],
          name: "are_painkillers_used",
          disabled: __props.disableInputs,
          modelValue: item.value.are_painkillers_used,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((item.value.are_painkillers_used) = $event))
        }, null, 8, ["disabled", "modelValue"]),
        (__props.errors['ob_gyn_history.are_painkillers_used'])
          ? (_openBlock(), _createElementBlock("p", _hoisted_39, _toDisplayString(__props.errors['ob_gyn_history.are_painkillers_used'][0]), 1))
          : _createCommentVNode("", true)
      ]),
      (item.value.are_painkillers_used == 'Yes')
        ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _createVNode(TextInput, {
                id: "medication_name",
                type: "text",
                placeholder: "Name of medication/薬品名",
                disabled: __props.disableInputs,
                modelValue: item.value.medication_name,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((item.value.medication_name) = $event)),
                error: __props.errors['ob_gyn_history.medication_name'] ? __props.errors['ob_gyn_history.medication_name'][0] : null
              }, null, 8, ["disabled", "modelValue", "error"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_42, [
      _hoisted_43,
      _createElementVNode("div", _hoisted_44, [
        _createElementVNode("div", _hoisted_45, [
          _createVNode(CalendarPicker, {
            id: "last_period_start_date",
            inline: false,
            placeholder: "Start Day/開始日",
            disabled: __props.disableInputs,
            modelValue: item.value.last_period_start_date,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((item.value.last_period_start_date) = $event)),
            error: __props.errors['ob_gyn_history.last_period_start_date'] ? __props.errors['ob_gyn_history.last_period_start_date'][0] : null
          }, null, 8, ["disabled", "modelValue", "error"])
        ]),
        _createElementVNode("div", _hoisted_46, [
          _createVNode(CalendarPicker, {
            id: "last_period_end_date",
            inline: false,
            placeholder: "End Day/終了日",
            disabled: __props.disableInputs,
            modelValue: item.value.last_period_end_date,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((item.value.last_period_end_date) = $event)),
            error: __props.errors['ob_gyn_history.last_period_end_date'] ? __props.errors['ob_gyn_history.last_period_end_date'][0] : null
          }, null, 8, ["disabled", "modelValue", "error"])
        ])
      ])
    ]),
    _hoisted_47,
    _createElementVNode("div", _hoisted_48, [
      _hoisted_49,
      _createElementVNode("div", _hoisted_50, [
        _createVNode(RadioGroup, {
          options: [
                        { id: 'yes', label: 'Yes/はい', value: 'Yes' },
                        { id: 'no', label: 'No/いいえ', value: 'No' },
                    ],
          name: "is_period_regular",
          disabled: __props.disableInputs,
          modelValue: item.value.had_sexual_intercourse,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((item.value.had_sexual_intercourse) = $event))
        }, null, 8, ["disabled", "modelValue"])
      ]),
      (__props.errors['ob_gyn_history.is_period_regular'])
        ? (_openBlock(), _createElementBlock("p", _hoisted_51, _toDisplayString(__props.errors['ob_gyn_history.had_sexual_intercourse'][0]), 1))
        : _createCommentVNode("", true)
    ]),
    _hoisted_52,
    _createElementVNode("div", _hoisted_53, [
      _hoisted_54,
      _createElementVNode("div", _hoisted_55, [
        _createVNode(RadioGroup, {
          options: [
                        { id: 'yes', label: 'Yes/はい', value: 'Yes'},
                        { id: 'no', label: 'No/いいえ', value: 'No'},
                    ],
          disabled: __props.disableInputs,
          name: "had_sexual_intercourse",
          modelValue: item.value.is_stds,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((item.value.is_stds) = $event)),
          error: __props.errors['ob_gyn_history.is_stds'] ? __props.errors['ob_gyn_history.is_stds'][0] : null
        }, null, 8, ["disabled", "modelValue", "error"]),
        (__props.errors['ob_gyn_history.is_stds'])
          ? (_openBlock(), _createElementBlock("p", _hoisted_56, _toDisplayString(__props.errors['ob_gyn_history.is_stds'][0]), 1))
          : _createCommentVNode("", true)
      ]),
      (item.value.is_stds == 'Yes')
        ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("div", _hoisted_59, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(std, (i) => {
                  return _createVNode(CheckboxInput, {
                    key: i,
                    id: i.label,
                    label: i.label,
                    rounded: false,
                    labelClass: "!text-base",
                    "text-color": "text-darkgray-800",
                    isChecked: inStdType(i.value),
                    disabled: __props.disableInputs,
                    onClick: ($event: any) => (addRemoveStdType(i.value))
                  }, null, 8, ["id", "label", "isChecked", "disabled", "onClick"])
                }), 64)),
                (inStdType('other'))
                  ? (_openBlock(), _createBlock(TextInput, {
                      key: 0,
                      id: "stds_type",
                      type: "text",
                      placeholder: "Type here",
                      modelValue: item.value.stds_type[getOtherValue()],
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((item.value.stds_type[getOtherValue()]) = $event)),
                      error: __props.errors['ob_gyn_history.stds_type'] ? __props.errors['ob_gyn_history.stds_type'][0] : null,
                      disabled: __props.disableInputs
                    }, null, 8, ["modelValue", "error", "disabled"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _hoisted_60
    ]),
    _hoisted_61,
    _createElementVNode("div", _hoisted_62, [
      _hoisted_63,
      _createElementVNode("div", _hoisted_64, [
        _createVNode(RadioGroup, {
          options: [
                        { id: 'yes', label: 'Yes/はい', value: 'Yes'},
                        { id: 'no', label: 'No/いいえ', value: 'No'},
                    ],
          name: "is_administering_hormone",
          disabled: __props.disableInputs,
          modelValue: item.value.is_administering_hormone,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((item.value.is_administering_hormone) = $event)),
          error: __props.errors['ob_gyn_history.is_administering_hormone'] ? __props.errors['ob_gyn_history.is_administering_hormone'][0] : null
        }, null, 8, ["disabled", "modelValue", "error"])
      ]),
      (__props.errors['ob_gyn_history.is_administering_hormone'])
        ? (_openBlock(), _createElementBlock("p", _hoisted_65, _toDisplayString(__props.errors['ob_gyn_history.is_administering_hormone'][0]), 1))
        : _createCommentVNode("", true),
      (item.value.is_administering_hormone == 'Yes')
        ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
            _createElementVNode("div", _hoisted_67, [
              _createVNode(TextInput, {
                id: "specify_hormone",
                type: "text",
                placeholder: "Please specify/薬品名",
                disabled: __props.disableInputs,
                modelValue: item.value.specify_hormone,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((item.value.specify_hormone) = $event)),
                error: __props.errors['ob_gyn_history.specify_hormone'] ? __props.errors['ob_gyn_history.specify_hormone'][0] : null
              }, null, 8, ["disabled", "modelValue", "error"])
            ]),
            _hoisted_68
          ]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_69,
    _hoisted_70,
    _createElementVNode("div", _hoisted_71, [
      _hoisted_72,
      _createElementVNode("div", _hoisted_73, [
        _createVNode(RadioGroup, {
          options: [
                        { id: 'yes', label: 'Yes/はい', value: 'Yes'},
                        { id: 'no', label: 'No/いいえ', value: 'No'},
                        { id: '3', label: 'Do not know / わからない', value: 'Do not know'},
                    ],
          name: "is_pregnant",
          disabled: __props.disableInputs,
          modelValue: item.value.is_pregnant,
          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((item.value.is_pregnant) = $event)),
          error: __props.errors['ob_gyn_history.is_pregnant'] ? __props.errors['ob_gyn_history.is_pregnant'][0] : null
        }, null, 8, ["disabled", "modelValue", "error"])
      ]),
      (__props.errors['ob_gyn_history.is_pregnant'])
        ? (_openBlock(), _createElementBlock("p", _hoisted_74, _toDisplayString(__props.errors['ob_gyn_history.is_pregnant'][0]), 1))
        : _createCommentVNode("", true),
      (item.value.is_pregnant == 'Yes')
        ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
            _createElementVNode("div", _hoisted_76, [
              _createVNode(TextInput, {
                id: "weeks_pregnant",
                type: "text",
                placeholder: "Weeks/週",
                disabled: __props.disableInputs,
                modelValue: item.value.weeks_pregnant,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((item.value.weeks_pregnant) = $event)),
                error: __props.errors['ob_gyn_history.weeks_pregnant'] ? __props.errors['ob_gyn_history.weeks_pregnant'][0] : null
              }, null, 8, ["disabled", "modelValue", "error"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_77, [
      _hoisted_78,
      _createElementVNode("div", _hoisted_79, [
        _createVNode(RadioGroup, {
          options: [
                        { id: 'yes', label: 'Yes/はい', value: 'Yes'},
                        { id: 'no', label: 'No/いいえ', value: 'No'},
                    ],
          name: "been_pregnant",
          disabled: __props.disableInputs,
          modelValue: item.value.been_pregnant,
          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((item.value.been_pregnant) = $event)),
          error: __props.errors['ob_gyn_history.been_pregnant'] ? __props.errors['ob_gyn_history.been_pregnant'][0] : null
        }, null, 8, ["disabled", "modelValue", "error"])
      ]),
      (__props.errors['ob_gyn_history.been_pregnant'])
        ? (_openBlock(), _createElementBlock("p", _hoisted_80, _toDisplayString(__props.errors['ob_gyn_history.been_pregnant'][0]), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_81, [
      _hoisted_82,
      _createElementVNode("div", _hoisted_83, [
        _createVNode(RadioGroup, {
          options: [
                        { id: '1', label: 'Yes/はい', value: 'Yes'},
                        { id: '2', label: 'No/いいえ', value: 'No'},
                    ],
          name: "has_miscarriage_abortion",
          disabled: __props.disableInputs,
          modelValue: item.value.has_miscarriage_abortion,
          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((item.value.has_miscarriage_abortion) = $event)),
          error: __props.errors['ob_gyn_history.has_miscarriage_abortion'] ? __props.errors['ob_gyn_history.has_miscarriage_abortion'][0] : null
        }, null, 8, ["disabled", "modelValue", "error"])
      ]),
      (__props.errors['ob_gyn_history.has_miscarriage_abortion'])
        ? (_openBlock(), _createElementBlock("p", _hoisted_84, _toDisplayString(__props.errors['ob_gyn_history.has_miscarriage_abortion'][0]), 1))
        : _createCommentVNode("", true),
      (item.value.has_miscarriage_abortion == 'Yes')
        ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
            _createElementVNode("div", _hoisted_86, [
              _hoisted_87,
              _createElementVNode("div", _hoisted_88, [
                _createVNode(RadioGroup, {
                  options: [
                                { id: '1', label: 'Once / １回', value: 'Once'},
                                { id: '2', label: 'Twice / 2 回', value: 'Twice'},
                                { id: '3', label: '3 times or more / ３回以上', value: 'More'},
                            ],
                  name: "miscarriage_count",
                  disabled: __props.disableInputs,
                  modelValue: item.value.miscarriage_count,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((item.value.miscarriage_count) = $event)),
                  error: __props.errors['ob_gyn_history.miscarriage_count'] ? __props.errors['ob_gyn_history.miscarriage_count'][0] : null
                }, null, 8, ["disabled", "modelValue", "error"])
              ]),
              _hoisted_89,
              _createElementVNode("div", _hoisted_90, [
                _createVNode(RadioGroup, {
                  options: [
                                { id: '1', label: 'Once / １回', value: 'Once'},
                                { id: '2', label: 'Twice / 2 回', value: 'Twice'},
                                { id: '3', label: '3 times or more / ３回以上', value: 'More'},
                            ],
                  name: "abortion_count",
                  disabled: __props.disableInputs,
                  modelValue: item.value.abortion_count,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((item.value.abortion_count) = $event)),
                  error: __props.errors['ob_gyn_history.abortion_count'] ? __props.errors['ob_gyn_history.abortion_count'][0] : null
                }, null, 8, ["disabled", "modelValue", "error"])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_91, [
      _hoisted_92,
      _createElementVNode("div", _hoisted_93, [
        _createVNode(RadioGroup, {
          options: [
                        { id: 'yes', label: 'Yes/はい', value: 'Yes'},
                        { id: 'no', label: 'No/いいえ', value: 'No'},
                    ],
          name: "has_children",
          modelValue: item.value.has_child,
          "onUpdate:modelValue": [
            _cache[23] || (_cache[23] = ($event: any) => ((item.value.has_child) = $event)),
            hasChild
          ],
          disabled: __props.disableInputs
        }, null, 8, ["modelValue", "disabled"])
      ])
    ]),
    (item.value.has_child == 'Yes')
      ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.value.children_delivery, (children, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "grid grid-cols-12 gap-x-8 gap-y-2.5 bg-primary-50 rounded-2xl p-5 lg:p-7 mb-2"
            }, [
              _createElementVNode("div", _hoisted_95, [
                _createElementVNode("p", _hoisted_96, _toDisplayString(children.child_order) + " " + _toDisplayString(getOrdinal(children.child_order)) + " child/第" + _toDisplayString(children.child_order) + "子 ", 1)
              ]),
              _createElementVNode("div", _hoisted_97, [
                (index != 0 && !__props.disableInputs)
                  ? (_openBlock(), _createElementBlock("small", {
                      key: 0,
                      class: "text-sm text-red-500 cursor-pointer",
                      onClick: ($event: any) => (removeChild(index))
                    }, " Remove ", 8, _hoisted_98))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_99, [
                _createVNode(TextInput, {
                  id: "age_deliver",
                  type: "text",
                  placeholder: "Age/年齢",
                  disabled: __props.disableInputs,
                  modelValue: children.age_deliver,
                  "onUpdate:modelValue": ($event: any) => ((children.age_deliver) = $event)
                }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
              ]),
              _createElementVNode("div", _hoisted_100, [
                _hoisted_101,
                _createElementVNode("div", _hoisted_102, [
                  _createVNode(RadioGroup, {
                    options: [
                                { id: '1', label: 'Vaginal delivery/経腟分娩', value: 'is_vaginal_delivery'},
                                { id: '2', label: 'C-section/帝王切開', value: 'is_csection_delivery'},
                            ],
                    name: 'delivery'+index,
                    disabled: __props.disableInputs,
                    modelValue: children.is_vaginal_delivery,
                    "onUpdate:modelValue": ($event: any) => ((children.is_vaginal_delivery) = $event)
                  }, null, 8, ["name", "disabled", "modelValue", "onUpdate:modelValue"])
                ])
              ])
            ]))
          }), 128)),
          (!__props.disableInputs)
            ? (_openBlock(), _createElementBlock("p", {
                key: 0,
                class: "text-sm font-bold transition cursor-pointer text-primary-500 hover:text-primary-700 w-fit",
                onClick: _cache[24] || (_cache[24] = ($event: any) => (addChild())),
                disabled: __props.disableInputs
              }, " Add another + ", 8, _hoisted_103))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _hoisted_104,
    _createElementVNode("div", _hoisted_105, [
      _hoisted_106,
      _createElementVNode("div", _hoisted_107, [
        _createVNode(RadioGroup, {
          options: [
                        { id: 'yes', label: 'Yes/はい', value: 'Yes'},
                        { id: 'no', label: 'No/いいえ', value: 'No'},
                    ],
          name: "is_breastfeeding",
          disabled: __props.disableInputs,
          modelValue: item.value.is_breastfeeding,
          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((item.value.is_breastfeeding) = $event)),
          error: __props.errors['ob_gyn_history.is_breastfeeding'] ? __props.errors['ob_gyn_history.is_breastfeeding'][0] : null
        }, null, 8, ["disabled", "modelValue", "error"])
      ]),
      (__props.errors['ob_gyn_history.is_breastfeeding'])
        ? (_openBlock(), _createElementBlock("p", _hoisted_108, _toDisplayString(__props.errors['ob_gyn_history.is_breastfeeding'][0]), 1))
        : _createCommentVNode("", true)
    ]),
    _hoisted_109,
    _createElementVNode("div", _hoisted_110, [
      _hoisted_111,
      _createElementVNode("div", _hoisted_112, [
        _createVNode(RadioGroup, {
          options: [
                        { id: 'yes', label: 'Yes/はい', value: 'Yes'},
                            { id: 'no', label: 'No/いいえ', value: 'No'},
                    ],
          name: "is_breast_surgery",
          disabled: __props.disableInputs,
          modelValue: item.value.is_breast_surgery,
          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((item.value.is_breast_surgery) = $event)),
          error: __props.errors['ob_gyn_history.is_breast_surgery'] ? __props.errors['ob_gyn_history.is_breast_surgery'][0] : null
        }, null, 8, ["disabled", "modelValue", "error"])
      ]),
      (__props.errors['ob_gyn_history.is_breast_surgery'])
        ? (_openBlock(), _createElementBlock("p", _hoisted_113, _toDisplayString(__props.errors['ob_gyn_history.is_breast_surgery'][0]), 1))
        : _createCommentVNode("", true)
    ]),
    _hoisted_114,
    _createElementVNode("div", _hoisted_115, [
      _hoisted_116,
      _createElementVNode("div", _hoisted_117, [
        _createVNode(RadioGroup, {
          options: [
                        { id: 'yes', label: 'Yes/はい', value: 'Yes'},
                        { id: 'no', label: 'No/いいえ', value: 'No'},
                    ],
          name: "is_breast_tested",
          disabled: __props.disableInputs,
          modelValue: item.value.is_breast_tested,
          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((item.value.is_breast_tested) = $event)),
          error: __props.errors['ob_gyn_history.is_breast_tested'] ? __props.errors['ob_gyn_history.is_breast_tested'][0] : null
        }, null, 8, ["disabled", "modelValue", "error"])
      ]),
      (__props.errors['ob_gyn_history.is_breast_tested'])
        ? (_openBlock(), _createElementBlock("p", _hoisted_118, _toDisplayString(__props.errors['ob_gyn_history.is_breast_tested'][0]), 1))
        : _createCommentVNode("", true),
      (item.value.is_breast_tested == 'Yes')
        ? (_openBlock(), _createElementBlock("div", _hoisted_119, [
            _createElementVNode("div", _hoisted_120, [
              _createVNode(CheckboxInput, {
                id: "Mammography/マンモグラフィ",
                label: "Mammography/マンモグラフィ",
                rounded: false,
                labelClass: "!text-base",
                "text-color": "text-darkgray-800",
                disabled: __props.disableInputs,
                isChecked: item.value.breast_mammography,
                "onUpdate:modelValue": _cache[28] || (_cache[28] = (value) => setDate(value, item.value,'breast_mammography'))
              }, null, 8, ["disabled", "isChecked"]),
              _createElementVNode("div", _hoisted_121, [
                (item.value.breast_mammography)
                  ? (_openBlock(), _createBlock(CalendarPicker, {
                      key: 0,
                      id: "breast_mammography",
                      inline: false,
                      placeholder: "Date of last 最後に受けた時期",
                      disabled: __props.disableInputs,
                      modelValue: item.value.breast_mammography,
                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((item.value.breast_mammography) = $event)),
                      error: __props.errors['ob_gyn_history.breast_mammography'] ? __props.errors['ob_gyn_history.breast_mammography'][0] : null
                    }, null, 8, ["disabled", "modelValue", "error"]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(CheckboxInput, {
                id: "Breast Ultrasound/乳腺超音波",
                label: "Breast Ultrasound/乳腺超音波",
                rounded: false,
                labelClass: "!text-base",
                "text-color": "text-darkgray-800",
                disabled: __props.disableInputs,
                isChecked: item.value.breast_ultrasound,
                "onUpdate:modelValue": _cache[30] || (_cache[30] = (value) => setDate(value, item.value, 'breast_ultrasound'))
              }, null, 8, ["disabled", "isChecked"]),
              _createElementVNode("div", _hoisted_122, [
                (item.value.breast_ultrasound)
                  ? (_openBlock(), _createBlock(CalendarPicker, {
                      key: 0,
                      id: "breast_ultrasound",
                      inline: false,
                      placeholder: "Date of last 最後に受けた時期",
                      disabled: __props.disableInputs,
                      modelValue: item.value.breast_ultrasound,
                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((item.value.breast_ultrasound) = $event)),
                      error: __props.errors['ob_gyn_history.breast_ultrasound'] ? __props.errors['ob_gyn_history.breast_ultrasound'][0] : null
                    }, null, 8, ["disabled", "modelValue", "error"]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(CheckboxInput, {
                id: "Visual Palpation/視触診",
                label: "Visual Palpation/視触診",
                rounded: false,
                labelClass: "!text-base",
                "text-color": "text-darkgray-800",
                disabled: __props.disableInputs,
                modelValue: item.value.breast_visual_palpation,
                "onUpdate:modelValue": [
                  _cache[32] || (_cache[32] = ($event: any) => ((item.value.breast_visual_palpation) = $event)),
                  _cache[33] || (_cache[33] = (value) => setDate(value, item.value, 'breast_visual_palpation'))
                ],
                error: __props.errors['ob_gyn_history.breast_visual_palpation'] ? __props.errors['ob_gyn_history.breast_visual_palpation'][0] : null,
                isChecked: item.value.breast_visual_palpation
              }, null, 8, ["disabled", "modelValue", "error", "isChecked"]),
              _createElementVNode("div", _hoisted_123, [
                (item.value.breast_visual_palpation)
                  ? (_openBlock(), _createBlock(CalendarPicker, {
                      key: 0,
                      id: "breast_ultrasound",
                      inline: false,
                      placeholder: "Date of last 最後に受けた時期",
                      disabled: __props.disableInputs,
                      modelValue: item.value.breast_visual_palpation,
                      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((item.value.breast_visual_palpation) = $event)),
                      error: __props.errors['ob_gyn_history.breast_visual_palpation'] ? __props.errors['ob_gyn_history.breast_visual_palpation'][0] : null
                    }, null, 8, ["disabled", "modelValue", "error"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_124,
    _createElementVNode("div", _hoisted_125, [
      _hoisted_126,
      _createElementVNode("div", _hoisted_127, [
        _createVNode(RadioGroup, {
          options: [
                        { id: 'Yes', label: 'Yes/はい', value: 'Yes'},
                        { id: 'No', label: 'No/いいえ', value: 'No'},
                    ],
          name: "had_pap_smear",
          disabled: __props.disableInputs,
          modelValue: item.value.had_pap_smear,
          "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((item.value.had_pap_smear) = $event)),
          error: __props.errors['ob_gyn_history.had_pap_smear'] ? __props.errors['ob_gyn_history.had_pap_smear'][0] : null
        }, null, 8, ["disabled", "modelValue", "error"])
      ]),
      (__props.errors['ob_gyn_history.had_pap_smear'])
        ? (_openBlock(), _createElementBlock("p", _hoisted_128, _toDisplayString(__props.errors['ob_gyn_history.had_pap_smear'][0]), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_129, [
        (item.value.had_pap_smear == 'Yes')
          ? (_openBlock(), _createElementBlock("div", _hoisted_130, [
              _createElementVNode("div", _hoisted_131, [
                _createVNode(CalendarPicker, {
                  id: "last_pap_smear_date",
                  inline: false,
                  placeholder: "Date of last pap smear 最後に受けた時期",
                  disabled: __props.disableInputs,
                  modelValue: item.value.last_pap_smear_date,
                  "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((item.value.last_pap_smear_date) = $event)),
                  error: __props.errors['ob_gyn_history.last_pap_smear_date'] ? __props.errors['ob_gyn_history.last_pap_smear_date'][0] : null
                }, null, 8, ["disabled", "modelValue", "error"])
              ]),
              _hoisted_132,
              _createVNode(RadioGroup, {
                options: [
                            { id: '1', label: 'Normal/異常なし', value: 'normal'},
                            { id: '2', label: 'Abnormal/異常あり', value: 'abnormal'},
                        ],
                name: "delivery",
                disabled: __props.disableInputs,
                "onUpdate:modelValue": [
                  _cache[37] || (_cache[37] = (value) => (item.value.pap_smear_result = value)),
                  _cache[38] || (_cache[38] = ($event: any) => ((item.value.pap_smear_result) = $event))
                ],
                modelValue: item.value.pap_smear_result,
                error: __props.errors['ob_gyn_history.pap_smear_result'] ? __props.errors['ob_gyn_history.pap_smear_result'][0] : null
              }, null, 8, ["disabled", "modelValue", "error"])
            ]))
          : _createCommentVNode("", true),
        _hoisted_133
      ])
    ])
  ]))
}
}

})